import type { ReactNode } from 'react';

type FilterBarProps = {
  children: ReactNode;
  className?: string;
  /**
   * Sessions-style toolbar: flush with the page (no card chrome).
   * @default true
   */
  embedded?: boolean;
};

/**
 * Toolbar row for search / selects / filter actions (evimo-incidents_v2 .list-tools).
 * Wrap with {@link EvimoListPanel} so toolbar + table share one card shell.
 * Use `FilterBarActions` + `FilterBarRefreshButton` / `FilterBarAddButton` for consistent actions.
 */
export function FilterBar({
  children,
  className,
  embedded = true,
}: FilterBarProps) {
  return (
    <div
      className={[
        'evimo-filter-bar',
        embedded ? 'evimo-filter-bar--embedded' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="toolbar"
    >
      {children}
    </div>
  );
}
